import type { ReactElement } from 'react';
import React from 'react';
import { type ErrorBoundaryProps, ErrorBoundary as GlitchTipErrorBoundary } from '@sentry/react';
import type { ButtonProps } from 'reactstrap';
import { Card, CardBody, CardHeader } from 'reactstrap';
import IconButton from 'atom-components/buttons/icon-button';
import MainLayout from 'layouts/main';

function ReloadButton(props: ButtonProps): ReactElement {
  return (
    <IconButton
      outline
      color="success"
      onClick={(): void => window.location.reload()}
      icon="arrow-rotate-right"
      {...props}
    >
      Reload the page
    </IconButton>
  );
}

export function NewFeatures(): ReactElement {
  return (
    <MainLayout title="New Features and Fixes">
      <Card outline color="success">
        <CardHeader>
          <h3>We've been busy</h3>
        </CardHeader>
        <CardBody>
          <p> We have been hard at work adding new features and squashing bugs.</p>
          <b>Please</b> <ReloadButton /> to see the latest improvements.
        </CardBody>
      </Card>
    </MainLayout>
  );
}

export function FallbackUI({ error }): ReactElement {
  if (error.name === 'ChunkLoadError' || error.message.includes('CSS chunk')) {
    return <NewFeatures />;
  }
  return (
    <MainLayout title="Error">
      <div className="alert alert-danger">
        Something went wrong, please <ReloadButton color="danger" />
      </div>
      <div className="alert alert-danger">{error.message}</div>
    </MainLayout>
  );
}

export function ErrorBoundary({
  children
}: React.PropsWithChildren<Omit<ErrorBoundaryProps, 'FallbackUI'>>): ReactElement {
  return <GlitchTipErrorBoundary fallback={FallbackUI}>{children}</GlitchTipErrorBoundary>;
}
